import * as React from 'react';

import { ApplicationState, ConnectedReduxProps } from '../../../../store';
import { IncidentAndDamage, Person } from '../../../../store/details/case/model';

import { Damage } from './damage';
import Incident from './incident';
import { PersonComponent } from '../person/person';
import { ResponsiblePartyComponent } from '../responsibleParty/responsibleParty';
import { connect } from 'react-redux';
import styles from './case.module.css';
import { CaseResponse } from 'src/store/case/model';

interface PropsFromState {
  readonly incidentAndDamage: IncidentAndDamage;
  readonly policyHolderRepresentative: Person;
  readonly policyHolderCounterExpert: Person;
  readonly responsableParty: Person;
  readonly responsablePartyExpert: Person;
  readonly case: CaseResponse;
}

type AllProps = PropsFromState & ConnectedReduxProps;

class Case extends React.Component<AllProps> {
  constructor(props: AllProps) {
    super(props);
  }

  render() {
    return (
      <div className={styles.container}>
        <div className={styles.scrollableContent}>
          <Incident header='details.case.incident.header' incident={this.props.incidentAndDamage} />
          <Damage header='details.case.damage.header' damage={this.props.incidentAndDamage} />
          <PersonComponent header='details.case.policyHolderRepresentative.header' person={this.props.policyHolderRepresentative} />
          <PersonComponent header='details.case.policyHolderCounterExpert.header' person={this.props.policyHolderCounterExpert} />
          <PersonComponent header='details.case.responsableParty.header' person={this.props.responsableParty} />
          <PersonComponent header='details.case.responsablePartyExpert.header' person={this.props.responsablePartyExpert} />
          <ResponsiblePartyComponent header='details.case.responsibleParty.policyInformation' case={this.props.case} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ details: { detailsCase } }: ApplicationState): PropsFromState => ({
  incidentAndDamage: detailsCase.incidentAndDamage,
  policyHolderRepresentative: detailsCase.policyHolderRepresentative,
  policyHolderCounterExpert: detailsCase.policyHolderCounterExpert,
  responsableParty: detailsCase.responsableParty,
  responsablePartyExpert: detailsCase.responsablePartyExpert,
  case: detailsCase.case,
});

export default connect(mapStateToProps, null)(Case);
